export const experiencesActionTypes = {
    ADD_EXPERIENCE: "ADD_EXPERIENCE",
    REMOVE_EXPERIENCE: "REMOVE_EXPERIENCE",
    CHANGE_EXPERIENCE: "CHANGE_EXPERIENCE",
    MOVE_EXPERIENCE_UP: "MOVE_EXPERIENCE_UP",
    MOVE_EXPERIENCE_DOWN: "MOVE_EXPERIENCE_DOWN",
    ADD_EXPERIENCE_ACTION: "ADD_EXPERIENCE_ACTION",
    REMOVE_EXPERIENCE_ACTION: "REMOVE_EXPERIENCE_ACTION",
    CHANGE_EXPERIENCE_ACTION: "CHANGE_EXPERIENCE_ACTION",
    MOVE_UP_EXPERIENCE_ACTION: "MOVE_UP_EXPERIENCE_ACTION",
    MOVE_DOWN_EXPERIENCE_ACTION: "MOVE_DOWN_EXPERIENCE_ACTION",
    ADD_EXPERIENCE_ROLE: "ADD_EXPERIENCE_ROLE",
    REMOVE_EXPERIENCE_ROLE: "REMOVE_EXPERIENCE_ROLE",
    CHANGE_EXPERIENCE_ROLE: "CHANGE_EXPERIENCE_ROLE",
    MOVE_EXPERIENCE_ROLE_UP: "MOVE_EXPERIENCE_ROLE_UP",
    MOVE_EXPERIENCE_ROLE_DOWN: "MOVE_EXPERIENCE_ROLE_DOWN",
}

export function experiencesReducer( experiences, action ) {
    let currentOrder = action.item.order;
    let parentOrder = action.parentOrder || 0;
    let updatedExperiences;

    switch ( action.type ) {
        case experiencesActionTypes.ADD_EXPERIENCE: {
            const requestedOrderedExperiences = Array.isArray( action.experienceOrders )
                ? action.experienceOrders
                    .map( order => experiences.find( experience => experience.order === order ) )
                    .filter( Boolean )
                : experiences;
            const orderedExperiences = requestedOrderedExperiences.length === experiences.length
                ? requestedOrderedExperiences
                : experiences;
            const insertionIndex = Number.isInteger( action.insertionIndex )
                ? Math.min( Math.max( action.insertionIndex, 0 ), orderedExperiences.length )
                : orderedExperiences.length;

            updatedExperiences = [
                ...orderedExperiences.slice( 0, insertionIndex ),
                action.item,
                ...orderedExperiences.slice( insertionIndex ),
            ].map( ( experience, index ) => ( {
                ...experience,
                order: index,
            } ) );
            break;
        }

        case experiencesActionTypes.REMOVE_EXPERIENCE:
            updatedExperiences = experiences
                .filter( experience => experience.order !== action.item.order )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( experience, index ) => {
                    experience.order = index;
                    return experience;
                } );
            break;

        case experiencesActionTypes.CHANGE_EXPERIENCE:
            updatedExperiences = experiences
                .map( experience => {
                        if ( experience.order === action.item.order ) {
                            return action.item
                        } else {
                            return experience
                        }
                    }
                )
            break;

        case experiencesActionTypes.MOVE_EXPERIENCE_UP:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === action.item.order ) {
                        experience.order--;
                    } else if ( experience.order === action.item.order - 1 ) {
                        experience.order++;
                    }
                    return experience
                } );
            break;

        case experiencesActionTypes.MOVE_EXPERIENCE_DOWN:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === currentOrder ) {
                        experience.order++;
                    } else if ( experience.order === currentOrder + 1 ) {
                        experience.order--;
                    }
                    return experience
                } );
            break;

        case experiencesActionTypes.ADD_EXPERIENCE_ACTION:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        if ( !experience.actions ) {
                            experience.actions = [];
                        }
                        return {
                            ...experience,
                            actions: [
                                ...experience.actions,
                                {
                                    order: experience.actions.length,
                                    text: action.item.text,
                                }
                            ].sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }
                } );
            break;

        case experiencesActionTypes.REMOVE_EXPERIENCE_ACTION:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            actions: experience.actions
                                .filter( experienceAction => experienceAction.order !== action.item.order )
                                .sort( ( a, b ) => a.order - b.order )
                                .map( ( experienceAction, index ) => {
                                    experienceAction.order = index;
                                    return experienceAction;
                                } )
                        }
                    } else {
                        return experience;
                    }
                } );
            break;

        case experiencesActionTypes.CHANGE_EXPERIENCE_ACTION:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            actions: experience.actions
                                .map( experienceAction => {
                                    if ( experienceAction.order === action.item.order ) {
                                        return action.item;
                                    } else {
                                        return experienceAction;
                                    }
                                } )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }
                } );
            break;

        case experiencesActionTypes.MOVE_UP_EXPERIENCE_ACTION:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            actions: experience.actions
                                .map(
                                    experienceAction => {
                                        if ( experienceAction.order === currentOrder ) {
                                            experienceAction.order--;
                                        } else if ( experienceAction.order === currentOrder - 1 ) {
                                            experienceAction.order++;
                                        }
                                        return experienceAction
                                    }
                                )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }

                } );
            break;

        case experiencesActionTypes.MOVE_DOWN_EXPERIENCE_ACTION:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            actions: experience.actions
                                .map(
                                    experienceAction => {
                                        if ( experienceAction.order === currentOrder ) {
                                            experienceAction.order++;
                                        } else if ( experienceAction.order === currentOrder + 1 ) {
                                            experienceAction.order--;
                                        }
                                        return experienceAction
                                    }
                                )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }

                } );
            break;

        case experiencesActionTypes.ADD_EXPERIENCE_ROLE:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        if ( !experience.roles ) {
                            experience.roles = [];
                        }
                        return {
                            ...experience,
                            roles: [
                                ...experience.roles,
                                {
                                    order: experience.roles.length,
                                    text: action.item.text,
                                }
                            ].sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }
                } );
            break;

        case experiencesActionTypes.REMOVE_EXPERIENCE_ROLE:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            roles: experience.roles
                                .filter( experienceRole => experienceRole.order !== action.item.order )
                                .sort( ( a, b ) => a.order - b.order )
                                .map( ( experienceRole, index ) => {
                                    experienceRole.order = index;
                                    return experienceRole;
                                } )
                        }
                    } else {
                        return experience;
                    }
                } );
            break;

        case experiencesActionTypes.CHANGE_EXPERIENCE_ROLE:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            roles: experience.roles
                                .map( experienceRole => {
                                    if ( experienceRole.order === action.item.order ) {
                                        return action.item;
                                    } else {
                                        return experienceRole;
                                    }
                                } )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }
                } );
            break

        case experiencesActionTypes.MOVE_EXPERIENCE_ROLE_UP:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            roles: experience.roles
                                .map(
                                    experienceRole => {
                                        if ( experienceRole.order === currentOrder ) {
                                            experienceRole.order--;
                                        } else if ( experienceRole.order === currentOrder - 1 ) {
                                            experienceRole.order++;
                                        }
                                        return experienceRole
                                    }
                                )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }

                } );
            break;

        case experiencesActionTypes.MOVE_EXPERIENCE_ROLE_DOWN:
            updatedExperiences = experiences
                .map( experience => {
                    if ( experience.order === parentOrder ) {
                        return {
                            ...experience,
                            roles: experience.roles
                                .map(
                                    experienceRole => {
                                        if ( experienceRole.order === currentOrder ) {
                                            experienceRole.order++;
                                        } else if ( experienceRole.order === currentOrder + 1 ) {
                                            experienceRole.order--;
                                        }
                                        return experienceRole
                                    }
                                )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return experience;
                    }

                } );
            break;

        default:
            throw new Error( `Unknown action: [${ action.type }]` );
    }
    return updatedExperiences.sort( ( a, b ) => a.order - b.order );
}
